import React from 'react'

function Password() {
    return (
        <div style={{height:'100%'}}>
            
        </div>
    )
}

export default Password
